const DropDownItemHeader = ({ text, className }) => (
  <div className={`mx-4 p-2 sa-dropdown-item-header font-medium text-sm leading-4 text-neutral-60 truncate ${className}`}>{text}</div>
);

export default DropDownItemHeader;
